<template>
  <div>
    <base-header
      type="gradient-danger"
      class="pb-6 pb-8 pt-5 pt-md-8"
    ></base-header>
    
    <div class="container-fluid mt--9">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <div class="card-header bg-transparent">
              <div class="row">
                <div class="col-sm-12">
                  <h3 class="mb-0">Migramos el Calendario de ST ADUANA a la nueva consola</h3>
                  <a href="https://consola-v2.canplast.net/" target="_blank" >
                    <h4 class="mb-0" style="color: #5e72e4;">Da click aquí para entrar a la nueva consola</h4>
                  </a>  
                </div>
              </div>
            </div>
            <div class="col-sm-12 mt-4 mb-4" >
              <center>
                <a href="https://consola-v2.canplast.net/" target="_blank">
                  <h1 class="pb-4">Aquí te mostramos como entrar al calendario de ST ADUANA en la nueva consola</h1>
                  <img
                    src="../../public/img/calendar-aduana.gif"
                    class="img-responsive"
                    style="max-width: 80%; height: auto"
                  />
                </a>
              </center>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style></style>

<script>

export default {
  components: {
  },
  created() {
  },
  beforeMount() {},
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {},
  computed: {},
};
</script>

<style lang="postcss" scoped>
::-webkit-scrollbar {
  width: 0px;
}
::-webkit-scrollbar-track {
  display: none;
}
/deep/ .custom-calendar.vc-container {
  --day-border: 1px solid #b8c2cc;
  --day-border-highlight: 1px solid #b8c2cc;
  --day-width: 90px;
  --day-height: 100px;
  --weekday-bg: #f8fafc;
  --weekday-border: 1px solid #eaeaea;
  border-radius: 0;
  width: 100%;
  & .vc-header {
    background-color: #f1f5f8;
    padding: 10px 0;
  }
  & .vc-weeks {
    padding: 0;
  }
  & .vc-weekday {
    background-color: var(--weekday-bg);
    border-bottom: var(--weekday-border);
    border-top: var(--weekday-border);
    padding: 5px 0;
  }
  & .vc-day {
    padding: 0 5px 3px 5px;
    text-align: left;
    height: var(--day-height);
    min-width: var(--day-width);
    background-color: white;
    &.weekday-1,
    &.weekday-7 {
      background-color: #eff8ff;
    }
    &:not(.on-bottom) {
      border-bottom: var(--day-border);
      &.weekday-1 {
        border-bottom: var(--day-border-highlight);
      }
    }
    &:not(.on-right) {
      border-right: var(--day-border);
    }
  }
  & .vc-day-dots {
    margin-bottom: 5px;
  }
}
</style>
